import { useContext } from "react";
import { GlobalTourContext } from "components/GlobalTourContext/GlobalTourContext";
import { useSearchParams } from "react-router-dom";



export const useGuidedNavigationCollection = () => {
    const tour = useContext(GlobalTourContext)!;
    const [searchParams] = useSearchParams();
    const qsKey = searchParams.get('gn.key');
    const qsStageNumber = searchParams.get('gn.stage_number');
    const qsDelayMs = searchParams.get('gn.delay_ms');

    const startTourFromQueryParams = async (): Promise<void> => {
        if (qsKey && qsStageNumber) {
            const delay = qsDelayMs ? parseInt(qsDelayMs, 10) : undefined;
            tour.continueTourAt(qsKey, parseInt(qsStageNumber, 10), delay ?? 0);
        }
    }

    return {
        startTourFromQueryParams,
    }
}